export { default } from "./WithLink";
export type { WithLinkProps } from "./WithLink";
